import './styles.scss';
import { useHistory } from 'react-router-dom';

interface ProfileSideBarProps {
  active: string;
  setActive: Function;
  options: Array<any>;
}

const ProfileSideBar = ({ active, setActive, options }: ProfileSideBarProps) => {
  const history = useHistory();
  return (
    <div className="nav flex-column nav-pills mr-4 left-side-container" id="v-pills-tab" role="tablist" aria-orientation="vertical">
      {options &&
        options.length &&
        options.map((option: any) => (
          <span
            className={`nav-link pointer ${active === option.key ? 'active' : ''}`}
            data-toggle="pill"
            key={option.key}
            role="tab"
            aria-controls="v-pills-home"
            aria-selected="true"
            onClick={() => setActive(option.key)}
          >
            {option.label}
          </span>
        ))}
      <span
        className={`nav-link pointer`}
        data-toggle="pill"
        key={'my-trips'}
        role="tab"
        aria-controls="v-pills-home"
        aria-selected="true"
        onClick={() => history.push('/my-trips')}
      >
        My Trips
      </span>
    </div>
  );
};

export default ProfileSideBar;
